<!--  -->
<template>
  <div>
    <div style="margin-bottom:10px" class="search_box">
      <el-input v-model="pageIfon.keywords" style="width:200px;margin-right:10px" placeholder="gh_id/appid" />
      <el-button icon="el-icon-search" type="primary" style="max-height:37px" @click="(pageIfon.page = 1),(resultlist())">搜索</el-button>
      <el-button icon="el-icon-refresh-left" type="primary" style="max-height:37px" @click="reset">重置</el-button>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="account_name"
        label="公众号"
        width="180"
        align="center"
      />
      <el-table-column
        prop="gh_id"
        label="ghId"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="appid"
        align="center"
      />
      <el-table-column
        prop="bind_status_text"
        label="绑定状态"
        align="center"
      />
      <el-table-column
        prop="send_open_id_count"
        label="发送用户数"
        width="180"
        align="center"
      />
      <el-table-column
        prop="success_open_id_count"
        label="成功发送用户数"
        width="180"
        align="center"
      />
      <el-table-column
        prop="send_status_text"
        label="发送状态"
        width="180"
        align="center"
      />
      <el-table-column
        prop="bind_time_text"
        label="绑定时间"
        align="center"
      />
      <el-table-column
        prop="bind_err_info"
        label="失败原因"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <!-- <el-button type="primary" :disabled="scope.row.publishStatus == 0" size="mini" @click="loojser(scope.row.id)">查看发布结果</el-button> -->
          <el-button v-if="scope.row.send_status == 1" type="danger" size="mini" @click="nopush(scope.row.task_no,scope.row.app_id)">停止推送</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { boundaccounts, fetchres, stopOfficialSend } from '@/api/sourceMaterial.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      pageIfon: {
        page: 1,
        pageSize: 10,
        keywords: null,
        task_no: null
      },
      total: null,
      tableData: [],
      id: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(val) {
      console.log('val', val)
      this.id = val
      this.resultlist()
    },
    async resultlist() {
      const data = await boundaccounts({
        ...this.pageIfon,
        task_no: this.id
      })
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.resultlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.resultlist()
    },
    async loojser(item) {
      const data = await fetchres({
        id: item
      })
      this.$message({
        type: 'success',
        message: '刷新成功!'
      })
      this.resultlist()
      console.log('data', data)
    },
    reset() {
      this.pageIfon.page = 1
      this.pageIfon.pageSize = 10
      this.pageIfon.keywords = null
      // this.pageIfon = {
      //   page: 1, // 页码
      //   pageSize: 10, // 页数
      //   keywords: null // 用户openid
      // }
      this.resultlist()
    },
    nopush(task_no, app_id) {
      this.$confirm('此操作将停止推送, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        stopOfficialSend({
          task_no: task_no,
          app_id: app_id
        }).then((res) => {
          this.resultlist()
          this.$message({
            type: 'success',
            message: '停止成功!'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消停止'
        })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
